import { render } from "./EducationExperience.vue?vue&type=template&id=0880853b"
import script from "./EducationExperience.vue?vue&type=script&lang=js"
export * from "./EducationExperience.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__